import { img } from "../constants/assets";

const brandLogos = [
  { src: "trip.svg", alt: "Trip" },
  { src: "sky.svg", alt: "Skyscanner" },
  { src: "airalo.svg", alt: "Airalo" },
  { src: "expedia.svg", alt: "Expedia" },
  { src: "KLOOK.svg", alt: "Klook" },
  { src: "traveloka.svg", alt: "Traveloka" },
  { src: "holafly.svg", alt: "Holafly" },
];

function LogoGroup({ duplicate = false }) {
  return (
    <div
      className="brands-marquee__group"
      aria-hidden={duplicate ? true : undefined}
    >
      {brandLogos.map((logo) => (
        <img
          key={`${duplicate ? "dup-" : ""}${logo.src}`}
          className="brand-logo"
          src={img(logo.src)}
          alt={duplicate ? "" : logo.alt}
        />
      ))}
    </div>
  );
}

function BrandsMarquee() {
  return (
    <div className="brands-marquee" aria-label="Trusted partner brands">
      <div className="brands-marquee__track">
        <LogoGroup />
        <LogoGroup duplicate />
      </div>
    </div>
  );
}

export default BrandsMarquee;
